var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.617188,
    y: 0.419922,
    width: 70.8073,
    height: 70.8073,
    rx: 11.8012,
    fill: "#0B60D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9009 33.8547C42.9009 30.0528 39.8188 26.9707 36.0169 26.9707C32.2149 26.9707 29.1328 30.0528 29.1328 33.8547C29.1328 37.6567 32.2149 40.7388 36.0169 40.7388C39.8188 40.7388 42.9009 37.6567 42.9009 33.8547Z",
    stroke: "white",
    strokeWidth: 2.95031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8647 34.5432C43.4981 34.7351 44.1698 34.8384 44.8656 34.8384C48.6676 34.8384 51.7497 31.7563 51.7497 27.9544C51.7497 24.1524 48.6676 21.0703 44.8656 21.0703C41.296 21.0703 38.3608 23.7873 38.0156 27.2662",
    stroke: "white",
    strokeWidth: 2.95031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0231 27.2662C33.6779 23.7873 30.7428 21.0703 27.1731 21.0703C23.3711 21.0703 20.2891 24.1524 20.2891 27.9544C20.2891 31.7563 23.3711 34.8384 27.1731 34.8384C27.869 34.8384 28.5408 34.7351 29.1739 34.5432",
    stroke: "white",
    strokeWidth: 2.95031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7006 44.6703C55.7006 39.239 50.8574 34.8359 44.8828 34.8359",
    stroke: "white",
    strokeWidth: 2.95031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8387 50.5746C46.8387 45.1433 41.9955 40.7402 36.0209 40.7402C30.0464 40.7402 25.2031 45.1433 25.2031 50.5746",
    stroke: "white",
    strokeWidth: 2.95031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1693 34.8359C21.1948 34.8359 16.3516 39.239 16.3516 44.6703",
    stroke: "white",
    strokeWidth: 2.95031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.633006946fe77dce2d24d1891c86f5a4.svg";
export { ForwardRef as ReactComponent };